import * as XLSX from 'xlsx';

/**
 * Satış raporlarını Excel formatında indirir
 * Özet ve detayları tek sayfada gösterir
 *
 * @param {Array} rows - DataGrid satırları
 * @param {Array} columns - DataGrid kolonları
 * @param {string} nodeId - Node ID
 * @param {Object} summaryData - Özet veriler (toplam satış, nakit, kart, mobil)
 */
export const exportSalesReport = (rows, columns, nodeId, summaryData = {}) => {
  try {
    if (!rows || rows.length === 0) {
      return { success: false, error: 'No data to export' };
    }

    // Workbook oluştur
    const workbook = XLSX.utils.book_new();

    // Tek sayfada hem özet hem detayları göstermek için veri hazırla
    const allData = [];

    // 1. Başlık ekle
    allData.push({ 'A': 'SATIŞ RAPORU' });
    allData.push({}); // Boş satır

    // 2. Özet bilgileri ekle
    if (summaryData && Object.keys(summaryData).length > 0) {
      allData.push({ 'A': 'ÖZET BİLGİLER' });
      allData.push({ 'A': 'Kategori', 'B': 'Tutar (TL)', 'C': 'Adet' });
      allData.push({
        'A': 'Toplam Satış',
        'B': (summaryData.totalAmount / 100).toFixed(2),
        'C': summaryData.totalCount || 0
      });
      allData.push({
        'A': 'Kart Satış',
        'B': (summaryData.cardAmount / 100).toFixed(2),
        'C': summaryData.cardCount || 0
      });
      allData.push({
        'A': 'Nakit Satış',
        'B': (summaryData.cashAmount / 100).toFixed(2),
        'C': summaryData.cashCount || 0
      });
      allData.push({
        'A': 'Mobil Satış',
        'B': (summaryData.mobileAmount / 100).toFixed(2),
        'C': summaryData.mobileCount || 0
      });
      allData.push({}); // Boş satır
      allData.push({}); // Boş satır
    }

    // 3. Detaylı satış verileri başlığı
    allData.push({ 'A': 'DETAYLI SATIŞ VERİLERİ' });

    // 4. Kolon başlıklarını ekle
    const headerRow = {};
    columns.forEach((column, index) => {
      const colLetter = String.fromCharCode(65 + index); // A, B, C, ...
      headerRow[colLetter] = column.headerName || column.field;
    });
    allData.push(headerRow);

    // 5. Satış detaylarını ekle
    rows.forEach(row => {
      const dataRow = {};
      columns.forEach((column, index) => {
        const colLetter = String.fromCharCode(65 + index);
        let value = row[column.field];
        dataRow[colLetter] = value !== undefined && value !== null ? value : '';
      });
      allData.push(dataRow);
    });

    // Worksheet oluştur
    const worksheet = XLSX.utils.json_to_sheet(allData, { skipHeader: true });

    // Sütun genişliklerini ayarla
    const maxCols = Math.max(...allData.map(row => Object.keys(row).length));
    const columnWidths = [];

    for (let i = 0; i < maxCols; i++) {
      const colLetter = String.fromCharCode(65 + i);
      const colData = allData.map(row => row[colLetter] || '');
      const maxLength = Math.max(
        ...colData.map(val => val.toString().length),
        10
      );
      columnWidths.push({ wch: Math.min(maxLength + 2, 30) });
    }

    worksheet['!cols'] = columnWidths;

    // Sayfa adı
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Satış Raporu');

    // Dosya adını tarih ile oluştur
    const now = new Date();
    const dateStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    const timeStr = `${String(now.getHours()).padStart(2, '0')}-${String(now.getMinutes()).padStart(2, '0')}`;
    const fileName = `Satis_Raporu_${nodeId || 'Node'}_${dateStr}_${timeStr}.xlsx`;

    // Excel dosyasını indir
    XLSX.writeFile(workbook, fileName);

    return { success: true, fileName };
  } catch (error) {
    console.error('Excel raporu oluşturulurken hata:', error);
    return { success: false, error: error.message };
  }
};
